/**
 * Chat API service.
 * Handles all chat-related API calls.
 */
import api from './api';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: string;
}

export interface ChatRequest {
  message: string;
  conversation_history?: ChatMessage[];
}

export interface ChatResponse {
  message: string;
  conversation_id?: string;
  timestamp: string;
}

export interface ChatStatus {
  enabled: boolean;
  configured: boolean;
  model: string | null;
}

/**
 * Send a message to the AI assistant.
 */
export const sendMessage = async (request: ChatRequest): Promise<ChatResponse> => {
  const response = await api.post('/api/v1/chat/message', request);
  return response.data;
};

/**
 * Check the status of chat functionality.
 */
export const getChatStatus = async (): Promise<ChatStatus> => {
  const response = await api.get('/api/v1/chat/status');
  return response.data;
};
